module.exports = __webpack_public_path__ + "static/media/71513161_453409265280407_2028330746902348804_n (1).da43bf2c.jpg";